import styled from 'styled-components';
import {Row} from '../../common/Layouts/Layouts';

// HOVER STUFF

export const HiddenDropdownWrapperDiv = styled.div`
  width: ${props => props.width || '20rem'};
  ${props => (props.top ? 'top: 1.5rem;' : 'bottom: 2rem;')}
  right: ${props => props.right || '-2rem'};
  max-width: ${props => props.width || '30rem'};
  padding: ${props => props.theme.spacing.base} 0;
  z-index: ${props => props.theme.misc.zIndex.base};
  visibility: hidden;
  transition: opacity 0.8s;
  position: absolute;
`;

export const HoverTargetWrapperDiv = styled.div`
  position: relative;
  text-align: left;
  display: inline-flex;
  &:hover > ${HiddenDropdownWrapperDiv} {
    visibility: visible;
  }
`;

export const TopDiv = styled.div(
  props => `
    background-color: ${props.theme.colors.white.base};
    border-radius: ${props.theme.misc.borderRadius.base};
    box-shadow: 0 ${props.theme.spacing.small.s5} ${props.theme.spacing.small.s4} ${props.theme.colors.shadow.base};
`,
);

export const TipUI = styled.div`
  position: absolute;
  margin-left: -${props => props.theme.spacing.base};
  width: 2.4rem;
  height: 1.2rem;
  overflow: hidden;
  &::after {
    content: '';
    position: absolute;
    width: 1.3rem;
    height: 1.2rem;
    left: 50%;
    background: ${props => props.theme.colors.white.base};
  }
`;

export const TipPositioning = styled(TipUI)`
  right: 15%;
  top: -0.2rem;
  &::after {
    transform: translate(-50%, 50%) rotate(45deg);
    background: ${props => props.bgColor};
    box-shadow: 0 ${props => props.theme.spacing.small.s1} ${props => props.theme.spacing.small.s4}
      ${props => props.theme.colors.shadow.base};
  }
`;

// CONTENT STUFF

export const ListDropDownWrapper = styled.ul(
  props => `
    width: 100%;
    display: flex;
    list-style-type: none;
    overflow: hidden;
    padding: ${props.theme.spacing.small.s5};
    flex-direction: column;
    background:${props.theme.colors.white.base};
    border-radius: ${props.theme.misc.borderRadius.base};
    flex-direction: column;
    > li {
      width: 100%;
      display: flex;
      flex-direction: row;
      padding: ${props.theme.spacing.base};
      position: relative;
      &:last-child {
        border-bottom: none;
      }
    }
`,
);

// CONTENT STUFF

export const IconWrapperDiv = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  display: flex;
  align-items: center;
  margin-right: 1.5rem;
`;

export const TextWrapper = styled.p(
  props => `
  padding-left: ${props.theme.spacing.small.s8};
  font-size: 12px;
  color: ${props.color || props.theme.colors.grey.base};
`,
);

export const BlueTextSpan = styled.span(
  props => `
  color: ${props.theme.colors.goBrand.blue};
  cursor: pointer;
`,
);

export const TextBlockDDHeading = styled(Row)`
  display: inline-flex;
  align-self: flex-start;
  align-items: center;
  padding: ${props => props.theme.spacing.small.s3} ${props => props.theme.spacing.base}
    ${props => props.theme.spacing.small.s3} ${props => props.theme.spacing.small.s5};
  background-color: white;
  color: ${props => props.theme.colors.goBrand.blue};
  border-radius: 2.5rem;
`;

export const TextBlockDDHeadingSpan = styled.span`
  color: ${props => props.color};
  background-color: ${props => props.bgColor};
  /* color: ${props => props.color || props.theme.colors.green.base}; */
  padding: 0 0 0 ${props => props.theme.spacing.small.s5};
`;

export const MiniIconWrapperSpan = styled.span`
  margin-right: ${props => props.theme.spacing.small.s5};
`;

export const AmenitiesHoverTitleSpan = styled.span`
  margin-bottom: 1rem;
`;
